import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", { src: "/assets/img/cart-icon.png" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!

  return (_openBlock(), _createBlock(_component_ion_toolbar, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                style: _normalizeStyle({ minHeight: (_ctx.safeTop/2) + 'px' }),
                class: "ion-text-center",
                size: "2"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_ion_button, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.voltar())),
                      size: "small",
                      fill: "#fff"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          slot: "start",
                          icon: _ctx.chevronBack
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["style"]),
              _createVNode(_component_ion_col, {
                class: "ion-text-center",
                size: "8"
              }),
              (_ctx.data.cart)
                ? (_openBlock(), _createBlock(_component_ion_col, {
                    key: 0,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.gotoCart())),
                    style: _normalizeStyle({ minHeight: (_ctx.safeTop/2) + 'px' }),
                    class: "ion-text-center",
                    size: "2"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _hoisted_1,
                        _createVNode(_component_ion_badge, { color: "danger" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.cartItemNumber), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_icon, { icon: _ctx.chevronForward }, null, 8, ["icon"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["style"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}